import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './styles/main.css'
import { useAuthStore } from '@/stores/auth'
import { initSessionLogger } from '@/utils/sessionLogger'
import { registerLicense }from '@syncfusion/ej2-base'

registerLicense('Ngo9BigBOggjHTQxAR8/V1JGaF5cXGpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWX1edHVcR2RfWUFwXEdWYEs=')

// Set dynamic page title from environment variable
document.title = import.meta.env.VITE_APP_DISPLAY_NAME || ' PULPIT'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)

const authStore = useAuthStore(pinia)
initSessionLogger(router, authStore)

app.mount('#app')
